import { CSSProperties } from 'react';
import {
  DatePicker as MUIDatePicker,
  DatePickerProps as MUIDatePickerProps,
} from '@mui/x-date-pickers/DatePicker';
import { PickersActionBarAction } from '@mui/x-date-pickers/PickersActionBar';

import colors from '@atom/styles/colors';

import PickerTextField from './PickerTextField';

const styles = {
  pickerIcon: {
    color: colors.neutral.gray,
  },
};

type CustomProps = {
  hideClear?: boolean;
};

type AtomMUIProps = {
  value: Date;
  onChange: (date: Date) => void;
  onClick?: () => void;
  onBlur?: () => void;
  style?: CSSProperties;
  disabled?: boolean;
  label?: string;
  error?: boolean;
  helperText?: string;
  InputProps?: any;
  InputLabelProps?: any;
  shouldDisableDate?: (date: Date) => boolean;
  disableFuture?: boolean;
};

export type DatePickerPropsNew = CustomProps & AtomMUIProps;

export const DatePicker = (props: DatePickerPropsNew) => {
  const {
    error,
    helperText,
    InputProps,
    InputLabelProps,
    style,
    onClick,
    onBlur,
    hideClear,
    ...data
  } = props;
  const MUIProps: MUIDatePickerProps = data;

  const actions: PickersActionBarAction[] = hideClear
    ? ['cancel']
    : ['cancel', 'clear'];

  return (
    <div style={{ width: '100%', ...style }}>
      <MUIDatePicker
        {...MUIProps}
        fullWidth
        slots={{ textField: PickerTextField }}
        slotProps={{
          actionBar: {
            actions,
          },
          textField: {
            fullWidth: true,
            error,
            helperText,
            InputProps,
            InputLabelProps,
            onClick,
            onBlur,
          },
          openPickerIcon: {
            style: styles.pickerIcon,
          },
        }}
      />
    </div>
  );
};
